import { render, staticRenderFns } from "./AddDismantle.vue?vue&type=template&id=af61f534&"
import script from "./AddDismantle.vue?vue&type=script&lang=js&"
export * from "./AddDismantle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports